// extracted by mini-css-extract-plugin
export default {"container":"nxvhd_JJ2E6vB9KamHK1"};